import React from 'react';
import { List } from '@mui/material';
import SettingsPanelSection from '../SettingsPanelSection';
import TextElementsEditor from '../../components/TextElementsEditor/TextElementsEditor';

class SettingsPanelSectionText extends React.Component {
    render() {
        return (
            <SettingsPanelSection
                title='Text'
            >
                <List 
                    dense 
                    disablePadding
                >
                    <TextElementsEditor advanced />
                </List>
            </SettingsPanelSection>
        );
    }
}

export default SettingsPanelSectionText;